import { useRequest } from '@/utils/request'

// useRequest() が返す関数の型を実体から導出する（手書きの複製を避け、シグネチャ変更に追従させる）。
type RequestFn = ReturnType<typeof useRequest>

export type AutoCloseReason = 'readFailed' | 'resultTimeout'

// 失敗確定プロセスの即時クローズ（#7709）。ベストエフォート: 失敗しても操作結果に
// 影響させない（従来どおり来訪時確認に残る=安全側）。fire-and-forget で発行し、
// エラー画面表示をブロックしない。
export function closeShareProcessBestEffort(
  request: RequestFn,
  processId: string,
  reason: AutoCloseReason
): void {
  void request(`/service/v2/share/request/process_id/${processId}`, {
    method: 'DELETE',
    showToast: false,
    showLoading: false,
  })
    .then(() => console.info('[process] auto-closed', { processId, reason }))
    .catch((e) =>
      console.warn('[process] auto-close failed (revisit-confirm will cover)', {
        processId,
        reason,
        e,
      })
    )
}
